module.exports = [
  require('./martial_arts_adept'),
  require('./master_thief'),
  require('./maw_demon'),
  require('./meenlock'),
  require('./mindwitness'),
  require('./morkoth'),
  require('./mouth_of_grolantor'),
]
